module.exports = __webpack_public_path__ + "logo.jpg?727f647d24486520452933861b9a4047";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/layout/logo.jpg
// module id = 101
// module chunks = 0